export default {
  LIST (state, value) {
    state.list = value || []
  }
}
